// Avoid letting users zoom the screen on iOS
document.addEventListener(
  "touchmove",
  function (event) {
    event = event.originalEvent || event;
    // Note that event.scale is undefined on android when scrolling so we have
    // to check for an undefined value too to avoid scroll prevention
    if (event.scale !== 1 && typeof event.scale !== "undefined") {
      event.preventDefault();
    }
  },
  { passive: false }
);

// Avoid browsers to automatically restore scroll during pushState and popState history
// actions, to avoid weird scroll restoration when navigating between pages.
if (history.scrollRestoration) {
  history.scrollRestoration = "manual";
}
